<template>
  <section class="mall-page-hero">
    <img class="mall-official-hero" src="@/assets/images/new-img/malls/down-picture.jpg" alt="美菜商城客户端下载" />
    <div class="subpage-hero-copy">
      <h1>美菜商城客户端下载</h1>
      <p>新鲜低价服务好 餐厅采购都在用</p>
      <div class="mall-downloads">
        <figure>
          <img src="@/assets/images/new-img/home/mc-app.png" alt="美菜商城 App 下载二维码" />
          <figcaption>扫码下载商城App</figcaption>
        </figure>
        <figure>
          <img src="@/assets/images/new-img/home/mc-wx.png" alt="美菜微信商城二维码" />
          <figcaption>扫描关注微信商城</figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MallHero"
};
</script>

<style lang="scss" scoped>
.mall-page-hero {
  position: relative;
  box-sizing: border-box;
  display: flex;
  min-height: 520px;
  padding: 55px clamp(40px, 8vw, 120px);
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
  font-size: 16px;
  line-height: 1.5;
}

.mall-official-hero {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mall-page-hero::after {
  position: absolute;
  inset: 0;
  content: "";
  background: linear-gradient(90deg, transparent 40%, rgba(249, 245, 236, 0.18) 55%, rgba(249, 245, 236, 0.54));
}

.subpage-hero-copy {
  position: relative;
  z-index: 1;
  width: 48%;
  max-width: 560px;
}

h1 {
  margin: 0 0 6px;
  color: #3a3d42;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: clamp(36px, 3.5vw, 52px);
  font-weight: 400;
  letter-spacing: -0.055em;
  line-height: 1.08;
}

.subpage-hero-copy > p {
  margin: 0;
  color: #666;
  font-size: 20px;
  line-height: 1.5;
}

.mall-downloads {
  display: flex;
  flex-wrap: wrap;
  margin-top: 58px;
  gap: 42px;
}

.mall-downloads figure {
  display: flex;
  width: 166px;
  margin: 0;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.mall-downloads img {
  box-sizing: border-box;
  width: 166px;
  height: 166px;
  padding: 8px;
  border-radius: 5px;
  background: #fff;
}

.mall-downloads figcaption {
  margin-top: 15px;
  color: #777;
  font-size: 14px;
  line-height: 1.5;
}

@media (min-width: 721px) and (max-width: 900px) {
  .subpage-hero-copy {
    width: 60%;
  }

  h1 {
    white-space: nowrap;
  }

  .mall-downloads {
    flex-direction: column;
    gap: 24px;
  }
}

@media (max-width: 720px) {
  .mall-page-hero {
    min-height: 650px;
    padding: 40px 20px;
    align-items: center;
  }

  .mall-page-hero::after {
    background: linear-gradient(0deg, rgba(249, 245, 236, 0.98), rgba(249, 245, 236, 0.62) 55%, transparent);
  }

  .subpage-hero-copy {
    width: 100%;
  }

  .mall-downloads {
    margin-top: 26px;
    gap: 16px;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .mall-downloads img {
    width: 120px;
    height: 120px;
  }

  .mall-downloads figure {
    width: 120px;
  }
}
</style>
